import axios from 'axios'
import { MessageBox } from 'element-ui'
import router from '../router'
import Cookies from 'js-cookie'
import store from '../store'
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 1000*31 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    const wParam = Cookies.get('Auth-Token')
    if (wParam) {
      config.headers['Auth-Token'] = wParam // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    //config.url = 'http://localhost:8902' + config.url
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非0是抛错
     */
    const res = response.data
    if (res.errcode === 0) {
      return res;
    } else if (res.errcode === 304) {
        store.commit('SET_USER_INFO', {cstNm: '', crdtNo: '', crdtTp: '', mobile: '', flag: '0'})
        router.push('/login')
        return Promise.reject('error')
    } else if (res.errcode === 306) {
        MessageBox({ title: '系统提示', message: res.msg, type: 'warning', customClass: 'err-cls' })
        return res
    } else {
        MessageBox({ title: '系统提示', message: res.msg, type: 'error', customClass: 'err-cls' })
        // Message({ message: res.msg, type: 'error' })
        return Promise.reject('error')
    }
  },
  error => {
      if (error.code === 'ECONNABORTED' && !error.config._retry) {
          console.log('取消请求')
          error.config._retry = true
          return service.request(error.config)
      } else {
          MessageBox({ title: '系统提示', message: error.message, type: 'error', customClass: 'err-cls' })
          return Promise.reject(error)
      }
  }
)

export default service
